import triggerDownload from "../../../helpers/triggerDownload";

export default filters => async (dispatch, getState, { api }) => {
  const response = await api.debtors.getDebtorsExport(filters);
  triggerDownload(response.download_url);
};
